<template>
  <div>
    <template v-if="type == 'desktop'">
      <p class="mb-2 body-2-2 font-bold text-18">{{$t('hotel.promo.promo-code')}}</p>
      <div class="position-relative">
        <input type="text" class="form-control body-2-2 font-semibold pr-5" :class="error != '' ? 'shake-el border-danger' : ''"
          v-model="promoCodeDisplay" :placeholder="$t('general.input-here')" @input="sendBackData()" @keyup.enter="loadPromoDetail()" @blur="applyOnBlur()" />
        <template v-if="form != ''">
          <p class="body-3 mb-0 mt-1 text-danger" v-if="error != ''">{{ error }}</p>
          <template v-if="is_not_in_date">
            <p class="body-3 mb-0 mt-1">Change your stay date to calim this promo.</p>
            <p class="body-2-4 text-green cursor-pointer" @click="setBackDate">Change Date</p>
          </template>
        </template>
        <div class="position-absolute" v-if="form != ''" style="right: 10px; top:8px;">
          <b-spinner small label="Small Spinner" v-if="is_load"></b-spinner>
          <template v-else>
            <svg v-if="error != ''" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#DC3545"/>
            </svg>
            <svg v-else width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.21184 11.664L1.73088 7.18301L0.204987 8.69816L6.21184 14.705L19.1067 1.81016L17.5915 0.295013L6.21184 11.664Z" fill="#28A745"/>
            </svg>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <p class="mb-0 body-2-2 text-22 font-bold d-inline-block">{{$t('hotel.promo.promo-code')}}</p>
      <p class="mb-0 body-2-2">{{$t('hotel.promo.desc')}}</p>
      <div class="mt-4 position-relative">
        <input 
          type="text" 
          class="form-control body-2-2 mb-2 font-bold text-18 pr-5" 
          :class="error != '' ? 'shake-el border-danger' : ''"
          v-model="promoCodeDisplay" 
          :placeholder="$t('general.input-here')" 
          @input="sendBackData()" 
          @keyup.enter="loadPromoDetail()" 
          @blur="applyOnBlur()" />

          <template v-if="form != ''">
          <p class="body-3 mb-0 mt-1 text-danger" v-if="error != ''">{{ error }}</p>
          <template v-if="is_not_in_date">
            <p class="body-3 mb-0 mt-1">Change your stay date to calim this promo.</p>
            <p class="body-2-4 text-green cursor-pointer" @click="setBackDate">Change Date</p>
          </template>
        </template>
        <div class="position-absolute" v-if="form != ''" style="right: 10px; top:8px;">
          <b-spinner small label="Small Spinner" v-if="is_load"></b-spinner>
          <template v-else>
            <svg v-if="error != ''" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#DC3545"/>
            </svg>
            <svg v-else width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.21184 11.664L1.73088 7.18301L0.204987 8.69816L6.21184 14.705L19.1067 1.81016L17.5915 0.295013L6.21184 11.664Z" fill="#28A745"/>
            </svg>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import {get} from '@/services/index'
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    props: {
      type:{
        type: String,
        default: 'desktop'
      },
      data: {
        type: String,
        default: ''
      },
      date:{
        type: Object,
        default: () => {} 
      }
    },
    data() {
      return {
        form: '',
        is_load: false,
        error: '',
        promo_detail: {},
        is_not_in_date: false,
        filter_date: {},
        new_start_date: moment().toDate()
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getBeFilter']),
      promoCodeDisplay: {
        get() {
          return this.form;
        },
        set(newValue) {
          this.form = newValue.toUpperCase();
        },
      }
    },
    mounted(){
      setTimeout(()=>{
        this.fillData()
        this.loadPromoDetail(false)
      },100)
    },
    methods:{
      fillData(){
        this.form = this.data
        if(Object.keys(this.date).length > 0) {
          this.filter_date = {
            start: this.$startDate(this.date.startDate),
            end: this.$endDate(this.date.endDate)
          }
        }else{
          this.filter_date = {
            start: this.$startDate(this.getBeFilter.date.check_in),
            end: this.$endDate(this.getBeFilter.date.check_out)
          }
        }
      },
      sendBackData(){
        this.$emit('update:data', this.form)
      },
      loadPromoDetail(hit_search=true){
        if(this.form != ''){
          this.is_load = true
          this.error = ''
          this.is_not_in_date = false
          get("CORE_HOTEL","promocode-detail",{
            merchant_id: this.getMerchant.id,
            promo_code: this.form
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.promo_detail = res.data
              if(res.data.stay_date.length > 0) this.checkDate()
            }else{
              this.error = res.message == 'data not found' ? 'Promo code not found' : res.message
            }
            this.is_load = false
          })
        }
      },
      checkDate(){
        this.is_not_in_date = false
        if(!this.promo_detail.is_use_custom_stay_days){
         this.new_start_date = moment(this.promo_detail.stay_date[0].start_date,'YYYY-MM-DD')
        }
        for (let i = 0; i < this.promo_detail.stay_date.length ; i++) {
          let item = this.promo_detail.stay_date[i];
          let promo_stay = {
            start: this.$startDate(moment(item.start_date,'YYYY-MM-DD')),
            end: this.$endDate(moment(item.end_date,'YYYY-MM-DD'))
          }
          let start_check = moment(this.filter_date.start).isBetween(promo_stay.start,promo_stay.end)
          let end_check = moment(this.filter_date.end).isBetween(moment(promo_stay.start).add(1,'d'),promo_stay.end)
          if(start_check || end_check){
            if(this.promo_detail.is_use_custom_stay_days){

              let valid_date_founded = false
            
              let total_night_promo = moment(promo_stay.end).diff(promo_stay.start,'days')
              for (let j = 0; j < total_night_promo; j++) {
                
                let promo_date = promo_stay.start
                if(j > 0) promo_date = moment(promo_date).add(j,'d')
                let promo_date_format = moment(promo_date).format("dddd")
              
                let key = `stay_${promo_date_format.toLocaleLowerCase()}`
                if(this.promo_detail[key]){
                  valid_date_founded = true
                  break;
                }
              }
              if(valid_date_founded){
                break;
              }else{
                if(i+1 == this.promo_detail.stay_date.length){
                  this.is_not_in_date = true
                  this.fillNewStartDateFilter()
                }
              }
            }else{
              break;
            }
          }else{
            if(i+1 == this.promo_detail.stay_date.length){
              this.is_not_in_date = true
              this.fillNewStartDateFilter()
            }
          }
        }
      },
      applyOnBlur(){
        if(!(this.promo_detail.id && this.form.localeCompare(this.promo_detail.promo_code, {sensitivity: 'case'}) == 0)){
          this.loadPromoDetail()
        }
      },
      fillNewStartDateFilter(){
        if(this.promo_detail.is_use_custom_stay_days){
          for(let i = 0; i < this.promo_detail.stay_date.length; i++){
            
            let promo_stay = {
              start: moment(this.promo_detail.stay_date[i].start_date,'YYYY-MM-DD'),
              end: moment(this.promo_detail.stay_date[i].end_date,'YYYY-MM-DD'),
            }
            let valid_date_founded = false
            
            let total_night_promo = moment(promo_stay.end).diff(promo_stay.start,'days')
            console.log("total_night_promo :", total_night_promo)
            for (let j = 0; j <= total_night_promo; j++) {
              
              let promo_date = promo_stay.start
              if(j > 0) promo_date = moment(promo_date).add(j,'d')
              let promo_date_format = moment(promo_date).format("dddd")
            
              let key = `stay_${promo_date_format.toLocaleLowerCase()}`
              console.log(`${i} - ${j} : ${key}`, this.promo_detail[key])
              if(this.promo_detail[key]){
                console.log("B")
                this.new_start_date = promo_date
                valid_date_founded = true
                break;
              }
            }
            if(valid_date_founded) break;
          }
        }else{
          console.log("A")
          this.new_start_date = moment(this.promo_detail.stay_date[0].start_date,'YYYY-MM-DD')
        }
      },
      setBackDate(){
        let total_night_filter = moment(this.filter_date.end).diff(this.filter_date.start,'days')
        let total_night = total_night_filter > this.promo_detail.min_night ? total_night_filter : this.promo_detail.min_night
        let params = {
          startDate: moment(this.new_start_date).toDate(),
          endDate: moment(moment(this.new_start_date).add(total_night,'d')).toDate()
        }
        this.$emit('update:date',params)
        this.$emit('hitSearch')
      }
    }
  }
</script>
<style>
  .shake-el{
    animation-name: horizontal-shaking;
    animation-duration: 0.25s;
    animation-iteration-count: 1;
  }

  @keyframes horizontal-shaking {
    0% { transform: translateX(0) }
    25% { transform: translateX(3px) }
    50% { transform: translateX(-3px) }
    75% { transform: translateX(3px) }
    100% { transform: translateX(0) }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/PromoCode.vue